import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("More Details")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    name: "Car",
    endpoint: "car",
    header: $setup.tableHeader,
    breadcrumbs: $setup.breadcrumbs,
    customProperties: $setup.customProperties,
    url: "lists",
    canCreate: false,
    loadingProp: $setup.loading,
    ref: "tableRef",
    modelValue: $setup.tableData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tableData) = $event)),
    filterData: $setup.filterData
  }, _createSlots({
    "cell-verifyState": _withCtx(({ row }) => [
      _createElementVNode("span", {
        class: _normalizeClass([
          row.verifyState === 'Done'
            ? 'badge-light-success text-w-emerald px-11'
            : 'badge-light-danger'
        , "badge px-8 py-3 fs-5"])
      }, _toDisplayString(row.verifyState === 'Done' ? 'Verified' : 'Unverified'), 3)
    ]),
    "cell-details": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        style: {"min-width":"151px"},
        class: "btn px-8 py-2 text-uppercase btn-primary",
        to: `lists/${row.id}`
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-createdAt": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString($setup.moment(row.createdAt).format('DD/MM/YYYY')), 1)
    ]),
    _: 2
  }, [
    _renderList($setup.loopers, (item, i) => {
      return {
        name: `cell-${item}`,
        fn: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row[item] || '-'), 1)
        ])
      }
    })
  ]), 1032, ["header", "breadcrumbs", "customProperties", "loadingProp", "modelValue", "filterData"]))
}